import { useEffect } from "react";

const SITE = "https://vanillaglobaltransindo.com";

// Updates the static head tags in place (single tag per type — no duplicates),
// restores homepage values on unmount. React 19 compatible.
export const Seo = ({ title, description, path = "/", image = "/images/og-cover.jpg", jsonLd = null }) => {
  const url = `${SITE}${path}`;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  const json = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const specs = [
      ['meta[name="description"]', { name: "description" }, description],
      ['meta[property="og:title"]', { property: "og:title" }, title],
      ['meta[property="og:description"]', { property: "og:description" }, description],
      ['meta[property="og:url"]', { property: "og:url" }, url],
      ['meta[property="og:image"]', { property: "og:image" }, img],
      ['meta[name="twitter:title"]', { name: "twitter:title" }, title],
      ['meta[name="twitter:description"]', { name: "twitter:description" }, description],
      ['meta[name="twitter:image"]', { name: "twitter:image" }, img],
    ];
    const undos = specs.map(([selector, attrs, content]) => {
      let el = document.head.querySelector(selector);
      const existed = !!el;
      const prev = existed ? el.getAttribute("content") : null;
      if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
      return () => {
        if (existed) el.setAttribute("content", prev);
        else el.remove();
      };
    });

    let canon = document.head.querySelector('link[rel="canonical"]');
    const canonExisted = !!canon;
    const canonPrev = canonExisted ? canon.getAttribute("href") : null;
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", url);

    let ldEl = null;
    if (json) {
      ldEl = document.createElement("script");
      ldEl.type = "application/ld+json";
      ldEl.textContent = json;
      document.head.appendChild(ldEl);
    }

    return () => {
      document.title = prevTitle;
      undos.forEach((undo) => undo());
      if (canonExisted) canon.setAttribute("href", canonPrev);
      else canon.remove();
      if (ldEl) ldEl.remove();
    };
  }, [title, description, url, img, json]);

  return null;
};
